import React, { lazy } from 'react'

export enum MSCRoutes {
  // PUBLIC ROUTES (smaller bundle)
  PublicHome = 'PublicHome',
  ExternalUser = 'ExternalUser',
  PrivacyPage = 'PrivacyPage',

  // PROTECTED ROUTES (larger bundle with /rafadmin calls)
  Home = 'Home',
  PrivateHome = 'PrivateHome',
  UploadUser = 'UploadUser',
  CoList = 'CoList',
  CoPage = 'CoPage',
  ProfilePage = 'ProfilePage',
  AppBrandings = 'AppBrandings',
  AppBrandingsPage = 'AppBrandingsPage',
  Brandings = 'Brandings',
  Branding = 'Branding',
  AppListPage = 'AppListPage',
  Categories = 'Categories',
  Category = 'Category',
  NewsListPage = 'NewsListPage',
  NewsListUpdatePage = 'NewsListUpdatePage',
  UsersPage = 'UsersPage',
  ExportDownload = 'ExportDownload'
}

// PUBLIC ROUTES - These create the "public" bundle
const PublicRoutes = {
  PublicHome: lazy(async () => await import('../PublicHome')),
  PrivacyPage: lazy(async () => await import('../PrivacyPage')),
}

// PROTECTED ROUTES - These create the "protected" bundle  
const ProtectedRoutes = {
  Home: lazy(async () => await import('../Home')),
  PrivateHome: lazy(async () => await import('../PrivateHome')),
  UploadUser: lazy(async () => await import('../UploadUser')),
  CoList: lazy(async () => await import('../CoList')),
  CoPage: lazy(async () => await import('../CoPage')),
  ProfilePage: lazy(async () => await import('../ProfilePage')),
  AppBrandings: lazy(async () => await import('../AppBrandings')),
  AppBrandingsPage: lazy(async () => await import('../AppBrandingsPage')),
  Brandings: lazy(async () => await import('../Brandings')),
  Branding: lazy(async () => await import('../Branding')),
  AppListPage: lazy(async () => await import('../AppListPage')),
  Categories: lazy(async () => await import('../Categories')),
  Category: lazy(async () => await import('../Category')),
  NewsListPage: lazy(async () => await import('../NewsListPage')),
  NewsListUpdatePage: lazy(async () => await import('../NewsListUpdatePage')),
  UsersPage: lazy(async () => await import('../UsersPage')),
  ExternalUser: lazy(async () => await import('../ExternalUser')),
  ExportDownload: lazy(async () => await import('../ExportDownload')),
}

type RouteNameToComponentResolver = {
  // React.ComponentType<any> is required because some pages are React.FC<{}>
  // rather than bare () => JSX.Element (e.g. ExportDownloadPage).
  [P in MSCRoutes]: React.LazyExoticComponent<React.ComponentType<any>>
}

const AllRoutes: RouteNameToComponentResolver = {
  ...PublicRoutes,
  ...ProtectedRoutes
}

interface RouteLoaderProps {
  name: MSCRoutes
}

export const LazyRouteLoader = (props: RouteLoaderProps): JSX.Element => {
  const LazyRoute = AllRoutes[props.name]

  return (
    <React.Suspense fallback={(<div>Loading...</div>)}>
      <LazyRoute />
    </React.Suspense>
  )
}